import { render, staticRenderFns } from "./reminderFrequency.vue?vue&type=template&id=25128110&scoped=true&"
import script from "./reminderFrequency.vue?vue&type=script&lang=js&"
export * from "./reminderFrequency.vue?vue&type=script&lang=js&"
import style0 from "./reminderFrequency.vue?vue&type=style&index=0&id=25128110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25128110",
  null
  
)

export default component.exports